import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const ScrollToTop = () => {
  const { pathname, hash, search } = useLocation();

  useEffect(() => {
    // Use requestAnimationFrame to avoid forced reflows
    const handleScroll = () => {
      requestAnimationFrame(() => {
        // If there's a hash, handle hash navigation after a small delay
        if (hash) {
          const element = document.getElementById(hash.substring(1));
          if (element) {
            element.scrollIntoView({ behavior: "smooth", block: "start" });
          }
        } else {
          // Otherwise, scroll to top
          window.scrollTo({ top: 0, left: 0, behavior: "auto" });
        }
      });
    };
    
    handleScroll();
  }, [pathname, hash, search]);

  return null;
};
